(() => {
  const angular = window.angular;

  angular.module('app').config(Router);

  Router.$inject = ['$stateProvider'];

  function Router($stateProvider) {
    $stateProvider.state('member.var.show.customer.show.project.operabilitySummary', {
      url: '/operability-summary',
      template: `<new-front-container path="'operability-summary'"></new-front-container>`,
      authenticated: true,
      ncyBreadcrumb: {
        label: '{{"entities.tool.__tools.OperabilitySummary" | translate}}',
      },
    });
  }
})();
